export default "__VITE_ASSET__rsBaEFml__"